const ackTypes = Object.freeze({
  resetAck: 'ResetAck',
  leaveAsIs: 'LeaveAsIs',
});

export default ackTypes;
